import { get, post, put, _delete } from '../actions/method';
import noti from '../actions/toast';

export const getSensorsByDept = async (deptId) => {
  return await get(`app/sensors/by-department/${deptId}`);
};

export const getAssignedSensorsByCurrentUser = async () => {
  return await get(`app/sensors/assigned/currentUser`);
};

export const lookupDepartments = async () => {
  return await get('app/lookup/departments?MaxResultCount=1000');
};

export const getMapsByDeptId = async (deptId) => {
  return await get(`app/maps/by-department/${deptId}`);
};

export const getMapInfo = async (deptId, mapName) => {
  return await get(`app/maps/mapShapes/${deptId}/${mapName}`);
};

export const getMapBg = async (deptId, mapName) => {
  return await get(`app/maps/background/${deptId}/${mapName}`);
};

export const postMapBackground = async (deptId, mapName, bgFile) => {
  const formData = new FormData();
  formData.set('file', bgFile);
  const params = { body: formData };
  return await post(`app/maps/background/${deptId}/${mapName}`, params)
    .then(() => noti.success('Map background is saved'))
    .catch((err) => {
      noti.error(err.response.data.error.message);
      throw err;
    });
};

export const postMapShapes = async (deptId, mapName, shapes) => {
  const params = { body: shapes };
  return await post(`app/maps/${deptId}/${mapName}`, params)
    .then(() => noti.success('Map shapes are saved'))
    .catch((err) => {
      noti.error(err.response.data.error.message);
      throw err;
    });
};

export const putMapBackground = async (deptId, mapName, bgFile) => {
  const formData = new FormData();
  formData.set('file', bgFile);
  const params = { body: formData };
  return await put(`app/maps/background/${deptId}/${mapName}`, params)
    .then(() => noti.success('Map background is saved'))
    .catch((err) => {
      noti.error('Updating map background unsuccessfully');
      throw err;
    });
};

export const putMapShapes = async (deptId, mapName, shapes) => {
  const params = { body: shapes };
  return await put(`app/maps/${deptId}/${mapName}`, params)
    .then(() => noti.success('Map shapes are saved'))
    .catch((err) => {
      noti.error('Updating map shapes unsuccessfully');
      throw err;
    });
};

export const deleteMap = async (deptId, mapName) => {
  return await _delete(`app/maps/${deptId}/${mapName}`)
    .then(() => noti.success('Map is removed'))
    .catch((err) => {
      throw err;
    });
};
